import React from 'react';
import { mockTechStack } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const TechStack = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [gridRef, gridVisible] = useScrollAnimation();
  const [bannerRef, bannerVisible] = useScrollAnimation();
  
  return (
    <section className="tech-stack-section" id="tech">
      <div className="section-container">
        <div 
          ref={headerRef}
          className={`section-header ${headerVisible ? 'animate-fade-in-up' : ''}`}
        >
          <h2 className="section-title">Built With Industry-Leading Tools</h2>
          <p className="section-subtitle">
            We leverage the most powerful automation and AI platforms to deliver results
          </p>
        </div>
        
        <div ref={gridRef} className="tech-stack-grid">
          {mockTechStack.map((tech, index) => {
            const delay = index * 100;
            return (
              <div 
                key={tech.name} 
                className={`tech-card ${gridVisible ? 'animate-fade-in-up' : ''}`}
                style={{ animationDelay: gridVisible ? `${delay}ms` : '0ms', opacity: gridVisible ? 1 : 0 }}
              >
                <div className="tech-card-inner">
                  <div className="tech-name">{tech.name}</div>
                  <div className="tech-category">{tech.category}</div>
                </div>
              </div>
            );
          })}
        </div>
        
        <div 
          ref={bannerRef}
          className={`tech-showcase-banner ${bannerVisible ? 'animate-scale-in' : ''}`}
          style={{ opacity: bannerVisible ? 1 : 0 }}
        >
          <div className="showcase-content">
            <div className="showcase-item">
              <div className="showcase-label">Automation</div>
              <div className="showcase-value">n8n</div>
            </div>
            <div className="showcase-divider"></div>
            <div className="showcase-item">
              <div className="showcase-label">Database</div>
              <div className="showcase-value">Supabase</div>
            </div>
            <div className="showcase-divider"></div>
            <div className="showcase-item">
              <div className="showcase-label">AI Agents</div>
              <div className="showcase-value">AutoGen</div>
            </div>
            <div className="showcase-divider"></div>
            <div className="showcase-item">
              <div className="showcase-label">AI Platform</div>
              <div className="showcase-value">Microsoft Foundry</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
